// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:40:04

export default {
  "id": "limited-kaboom",
  "slug": "limited-kaboom",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/965a0665c71d43268ed953a76d82e30a-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/965a0665c71d43268ed953a76d82e30a/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Limited Kaboom",
      "description": "Use your buddies to take down the enemy structures and the enemies along with them! \nCan you make survive the hero? \nUse the physics of the world to skillfully take down Sam's enemies!",
      "instructions": "Drag to Aim, Release to shoot",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "throwing"
      ]
    },
    "zh-CN": {
      "title": "限时炸裂",
      "description": "利用你的伙伴摧毁敌人建筑以及敌人！\n你能让英雄幸存下来吗？\n利用世界的物理原理巧妙地摧毁山姆的敌人！",
      "instructions": "拖动瞄准，松开射击",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1玩家",
        "投掷"
      ]
    },
    "zh-TW": {
      "title": "限量爆裂",
      "description": "利用你的夥伴擊毀敵方結構和敵人！\n你能讓英雄存活下來嗎？\n利用世界的物理學巧妙地擊敗Sam的敵人！",
      "instructions": "拖動以對準，放開以射擊",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "投擲"
      ]
    },
    "zh-HK": {
      "title": "限量炸彈",
      "description": "用你的夥伴攻擊敵人結構，以及敵人本身！\n你能讓英雄倖存嗎？\n利用世界的物理學巧妙地擊敗Sam的敵人！",
      "instructions": "拉來對準，放開射擊",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人",
        "投擲"
      ]
    },
    "ja": {
      "title": "限定的爆発",
      "description": "仲間を使って敵の構造物とその敵を倒せ！ヒーローを生き延びさせられるか？世界の物理法則を使ってサムの敵を巧みに倒せ！",
      "instructions": "ドラッグして照準を当て、リリースして撃つ",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "投げる"
      ]
    },
    "ko": {
      "title": "한정된 kaboom",
      "description": "친구들을 사용하여 적의 구조물과 그들과 함께 무너뜨리세요!\n영웅을 생존시킬 수 있을까요?\n세계의 물리학을 사용하여 Sam의 적들을 세련되게 무너뜨리세요!",
      "instructions": "드래그하여 정확도를 조절하고, 레이스하여 발사합니다.",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "던지는"
      ]
    },
    "fr": {
      "title": "Kaboom limité",
      "description": "Utilisez vos amis pour abattre les structures ennemies et leurs occupants en même temps !\nPouvez-vous faire survivre le héros ?\nUtilisez la physique du monde pour prendre habilement d'assaut les ennemis de Sam !",
      "instructions": "Tirer pour viser, relâcher pour tirer",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "lanceur"
      ]
    }
  }
};
